import { JobStatus, JobTypes, PEOPLE_SORT_OPTIONS } from "@lib/enums";
import { useJobStatus } from "@lib/jobs/useJobStatus";
import { useEffect, useRef } from "react";

export default function useImportingStatus({
  setSortBy,
  resetList,
  invalidate,
}) {
  // Tracks whether we're currently in an importing run. Kept as a ref (not
  // state) because it's only read/written inside the status-change effect to
  // detect the rising edge of a new import — it never needs to trigger a render.
  const isImportingRef = useRef(false);

  const { jobs } = useJobStatus(JobTypes.AI, [
    JobStatus.IMPORTING_CV,
    JobStatus.FAILED,
    JobStatus.COMPLETE,
  ]);

  // for useEffect dependency
  // only update when ids or statuses have changed
  const idStatusMap = jobs.reduce((acc, job) => {
    acc[job.id] = job.status;
    return acc;
  }, {});

  const processing =
    jobs?.filter((job) => job.status === JobStatus.IMPORTING_CV) || [];

  useEffect(() => {
    // if we have new importing jobs, reset the table to show latest first
    if (!isImportingRef.current && processing.length > 0) {
      isImportingRef.current = true;
      setSortBy({
        property: PEOPLE_SORT_OPTIONS.UPDATED_AT,
        direction: "desc",
      });
      resetList();
      invalidate();
      return;
    }

    // refetch after any change in status
    invalidate();

    if (isImportingRef.current && processing.length === 0) {
      isImportingRef.current = false;
    }
  }, [JSON.stringify(idStatusMap)]);

  return { jobs };
}
